const route = {
  path: '/profile',
  name: 'MyProfile',
  component: () => import(/* webpackChunkName: "profile" */ '@/views/MyProfile'),

}

export default route
